import { render, staticRenderFns } from "./kpi-pay.vue?vue&type=template&id=0861c566&scoped=true"
import script from "./kpi-pay.vue?vue&type=script&lang=js"
export * from "./kpi-pay.vue?vue&type=script&lang=js"
import style0 from "./kpi-pay.vue?vue&type=style&index=0&id=0861c566&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0861c566",
  null
  
)

export default component.exports